import { NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Box } from "@chakra-ui/react";
import { HorizontalGreyBlackFieldInput } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { UseFormReturn, useController } from "react-hook-form";

interface MeetingDurationFieldProps {
  form: UseFormReturn<any>;
  fieldName: string;
  label?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
}

export default function MeetingDurationField({
  form,
  fieldName,
  label = "Duration (minutes)",
  isRequired = false,
  isDisabled = false,
  min = 1,
  max = 480, // 8 hours max
  step = 15,
}: MeetingDurationFieldProps) {
  const { control, formState: { errors } } = form;
  const {
    field: { onChange, value },
  } = useController({
    name: fieldName,
    control,
  });

  return (
    <HorizontalGreyBlackFieldInput
      label={label}
      labelContainerProps={longAttributeStyles.labelContainerProps}
      labelProps={{ marginBottom: 0 }}
      name={fieldName}
      required={isRequired}
      disabled={isDisabled}
      errors={errors}
    >
      <Box w="72px">
        <NumberInput
          value={value || "30"}
          onChange={(_, valueAsNumber) => onChange(valueAsNumber || 0)}
          min={min}
          max={max}
          step={step}
          isDisabled={isDisabled}
          size="sm"
        >
          <NumberInputField placeholder="Enter minutes" borderRadius="5px" />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
      </Box>
    </HorizontalGreyBlackFieldInput>
  );
}
